<div id="heading" class="standard-heading">
  <h1>Research Project</h1>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
      <li class="breadcrumb-item"><a href="#">About Us</a></li>
      <li class="breadcrumb-item" routerLink="/about/research-centre"><a href="#">Research Centre</a></li>
      <li class="breadcrumb-item active" aria-current="page">Research Project</li>
    </ol>
  </nav>
</div>

<section id="research-project" class="py-5">
  <div class="container">
    <div class="card shadow-lg content-main-card border-0">
      <div class="card-body p-4 p-md-5 text-center">
        <h2 class="card-title text-uppercase mb-3">Research Project</h2>
        <hr class="mx-auto mb-5 custom-hr">

        <div class="project-details text-start d-inline-block">
          <ol class="lead text-justify mb-0" style="font-size: 1.3rem; line-height: 2.1rem; font-weight: 500;">
            <li class="mb-2">
              "The Role of Sri Guru Granth Sahib in the Socio-Cultural Renaissance of India" Sponsored by the Indian
              Council of Social Science Research, New Delhi (2026).
            </li>
            <li class="mb-2">
              "Contribution of Sikh Gurus to Indian National Consciousness with Special Reference to Sri Guru Tegh Bahadur’s Life & Teachings." Sponsored by the Indian Council of Historical Research.
            </li>
            <li class="mb-2">
              The Sahitya Akademi, New Delhi, has assigned a research project to prepare a book titled “The Reader on the Sikh Gurus and Indian Civilizational Pluralism.”
            </li>
          </ol>
        </div>

        <div class="mt-5">
          <button class="btn btn-danger" routerLink="/about/research-centre">Back to Research Centre</button>
        </div>
      </div>
    </div>
  </div>
</section>